// extracted by mini-css-extract-plugin
module.exports = {"uploadWrapper":"component_uploadWrapper__1Fsil","error":"component_error__2oYVz","upload":"component_upload__ttTXc"};